import { xcss } from '@atlaskit/primitives';
import Pressable from '@atlaskit/primitives/pressable';
import { Ratings as RatingsV1 } from '@atlassian/amkt-common';
import { LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { Ratings as RatingsV2 } from '@atlassian/mpac-primitives';
import { UrlUtils, WindowUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { useHistory } from '../../../../primitives/Router';
import { ANALYTICS_SUBJECT_ID_RATINGS } from '../../AppHeader.constants';
import { jsx as _jsx } from "react/jsx-runtime";
const pressableStyles = xcss({
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.subtle.pressed'
  },
  borderRadius: 'border.radius.100',
  paddingLeft: 'space.0',
  paddingRight: 'space.0'
});
const HeaderRatings = props => {
  const history = useHistory();
  const {
    appRatingLink,
    openMarketplaceLinksInNewTab,
    appKey,
    ratings,
    showAetherAppListingPage
  } = props;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const onRatingsClick = () => {
    fireAnalyticsEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_RATINGS
    });
    if (openMarketplaceLinksInNewTab) {
      const appReviewsUrl = appRatingLink.expand({
        appKey
      });
      WindowUtils.openPage(appReviewsUrl, '_blank');
    } else {
      history === null || history === void 0 ? void 0 : history.push(UrlUtils.updateQueryParam(window.location.href, 'tab', 'reviews'));
    }
  };
  if (showAetherAppListingPage) {
    return /*#__PURE__*/_jsx(Pressable, {
      xcss: pressableStyles,
      backgroundColor: "color.background.neutral.subtle",
      onClick: onRatingsClick,
      children: /*#__PURE__*/_jsx(RatingsV2, {
        ratings: ratings,
        testId: "app-header-ratings",
        showNoRatingsMessage: true,
        boldAverageStars: true
      })
    });
  }
  return /*#__PURE__*/_jsx(RatingsV1, {
    ratings: ratings,
    onClick: ratings.numRatings ? onRatingsClick : undefined
  });
};
export default HeaderRatings;